import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';
import config from 'config';
import version from '../version.json';

export function initDatadogRum(): void {
    if (!config.DATADOG_APPLICATION_ID || !config.DATADOG_CLIENT_TOKEN) {
        console.warn(
            'Datadog RUM not initialized: REACT_APP_DATADOG_APPLICATION_ID or REACT_APP_DATADOG_CLIENT_TOKEN is missing.'
        );
        return;
    }

    datadogRum.init({
        applicationId: config.DATADOG_APPLICATION_ID,
        clientToken: config.DATADOG_CLIENT_TOKEN,
        site: config.DATADOG_SITE || 'datadoghq.com',
        service: 'admin-portal',
        env: config.ENV,
        version: version.version,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 0,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
        plugins: [reactPlugin({ router: true })],
        // Only bt-admin-api: GFE_* is a third-party Google Fleet Engine origin and MFE_BASE_URL
        // is a full-page navigation target, neither is an XHR/fetch call this SDK instruments.
        allowedTracingUrls: config.API_URL ? [config.API_URL] : [],
    });
}

export { datadogRum };
